import { render } from "./moePage.vue?vue&type=template&id=39640d31&scoped=true"
import script from "./moePage.vue?vue&type=script&lang=js"
export * from "./moePage.vue?vue&type=script&lang=js"

import "./moePage.vue?vue&type=style&index=0&id=39640d31&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39640d31"]])

export default __exports__